export const UPDATE_LIST_OF_BUSINESSES = 'UPDATE_LIST_OF_BUSINESSES'
export const SET_BUSINESSES_ERROR = 'SET_BUSINESSES_ERROR'
export const CLEAR_BUSINESSES_ERROR = 'CLEAR_BUSINESSES_ERROR'
export const SET_CURRENT_BUSINESS = 'SET_CURRENT_BUSINESS'
export const DELETE_BUSINESS = 'DELETE_BUSINESS'
